import { Widget } from "blue-widgets";
import debounce from "../tools/debounce";

class TabNavigation extends Widget {
  constructor(el) {
    super(el);

    this.linkContainer = this.el.querySelector("[data-link-container]");
    this.links = Array.from(this.linkContainer.querySelectorAll("a"));
    this.sections = [];
    this.positions = [];
    this.currentActiveIndex = null;
    this.lastActiveIndex = null;

    this.init();
    window.addEventListener("scroll", this.debouncedScroll);
    window.addEventListener("resize", this.setPositions);
    // Set positions and active section after layout shifts have taken place
    document.addEventListener("DOMContentLoaded", () => {
      this.setPositions();
      this.setActive();
    });
  }

  init() {
    // Get all the sections
    this.sections = this.links.map((link) => {
      const id = link.href.split("#")[1];
      return document.getElementById(id);
    });

    // Set positions of sections and links
    this.setPositions();

    // Set scroll margin for each section
    this.setScrollMargin();

    // Set first active before scroll takes place
    this.setFirstActive();
  }

  setActive = () => {
    let closest = Infinity;

    this.sections.forEach((section, index) => {
      const top = this.positions[index].sectionTop - window.scrollY;
      if (top > 0 && top < closest) closest = index;
    });

    // If all sections are above viewport, set last as active
    if (closest === Infinity) {
      this.currentActiveIndex = this.sections.length - 1;
    } else {
      // Else set closest as active
      this.currentActiveIndex = closest;
    }

    // If active section has changed
    if (this.lastActiveIndex !== this.currentActiveIndex) {
      // remove last active
      if (this.lastActiveIndex !== null) {
        this.links[this.lastActiveIndex].parentElement.classList.remove(
          "active"
        );
      }

      // set active
      this.links[this.currentActiveIndex].parentElement.classList.add("active");
    }

    this.lastActiveIndex = this.currentActiveIndex;
  };

  // Set the scroll-margin-top property on each section to account for sticky elements
  setScrollMargin = () => {
    this.sections.forEach((section) => {
      section.style.scrollMarginTop =
        "calc(var(--header-height) + var(--tab-nav-height))";
    });
  };

  // Check which section is closest to the top of the viewport and set as active
  setFirstActive = () => {
    let closest = Infinity;
    this.sections.forEach((section) => {
      const top = section.getBoundingClientRect().top;
      if (top > 0 && top < closest) {
        closest = this.sections.indexOf(section);
      }
    });
    this.currentActiveIndex = closest;
    this.setActive();
  };

  debouncedScroll = () => debounce(this.setActive, 300);

  // Set positions of sections
  setPositions = () => {
    const scrollY = window.scrollY;
    this.sections.forEach((section, index) => {
      this.positions[index] = {
        sectionTop: Math.floor(section.getBoundingClientRect().top + scrollY)
      };
    });
  };

  beforeRemove() {
    window.removeEventListener("scroll", this.debouncedScroll);
    window.removeEventListener("resize", this.setPositions);
  }
}

export default TabNavigation;
